<template>
  <el-card class="list-selector">
    <ul class="list-selector-list">
      <li @click="swatchAdminShopId({ shopId: '', shopName: '全部' })"
        :class="{ 'selected': adminShopInfo.shopId === '' }" v-if="showAll == 'Y'">
        {{ $t('common.all') }}
      </li>
      <li v-for="(item, index) in adminShopInfo.shops" :key="index"
        @click="swatchAdminShopId(item)"
        :class="{ 'selected': adminShopInfo.shopId === item.shopId }">
        {{ item.shopName }}
      </li>
    </ul>
  </el-card>
</template>

<script>
import { queryShopsByAdmin } from '@/api/shop/shopApi'

export default {
  name: 'AdminShop',
  data() {
    return {
      adminShopInfo: {
        shops: [],
        shopId: ''
      }
    }
  },
  props: {
    showAll: {
      type: String,
      default: 'Y'
    }
  },
  created() {
    this._listAdminShops()
  },
  methods: {
    async _listAdminShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.adminShopInfo.shops = res.data
        if(this.showAll == 'N' && this.adminShopInfo.shops.length > 0){
          this.swatchAdminShopId(this.adminShopInfo.shops[0])
        }
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    swatchAdminShopId(shop) {
      this.adminShopInfo.shopId = shop.shopId
      this.$emit('shop-change', shop)
    }
  }
}
</script>

<style scoped>
/* 使用全局 list-selector 样式，无需自定义样式 */
</style>